import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface GetCompletedPuzzlesCoachPayload {
  meetingId: string;
  occurenceId: string;
}

export default function useGetCompletedPuzzlesCoachApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, GetCompletedPuzzlesCoachPayload> {
  return useMutation<any, unknown, GetCompletedPuzzlesCoachPayload>(
    async (payload: GetCompletedPuzzlesCoachPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_completed_puzzles_for_coach/',
        payload,
      );
      console.log(
        'get Completed Classroom Puzzles For Coach response ',
        response.data,
      );
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error(
          'Failed to get Completed Classroom Puzzles For Coach :',
          error,
        );
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
